import Vue from "vue";
import Vuex from "vuex";
import { fetchWithAuth } from "./utils/fetchWithAuth";

Vue.use(Vuex);
import VueCookie from "vue-cookies";

export default new Vuex.Store({
  state: {
    alert_state: false,
    alert_message: "",
    loading_state: false,
    btn_state: false,
    semesters: [],
    select_semester: "",
    departments: [],
    selectDepartment: "",
    dimensions: [],
    select_dimension: "",
    show_time_table: false,
    times: [
      "1",
      "2",
      "3",
      "4",
      "5",
      "6",
      "7",
      "8",
      "9",
      "10",
      "A",
      "B",
      "C",
      "D",
    ],
    days: ["M", "T", "W", "R", "F", "S", "U"],
    nodes: [
      "M1",
      "M2",
      "M3",
      "M4",
      "M5",
      "M6",
      "M7",
      "M8",
      "M9",
      "M10",
      "MA",
      "MB",
      "MC",
      "MD",
      "T1",
      "T2",
      "T3",
      "T4",
      "T5",
      "T6",
      "T7",
      "T8",
      "T9",
      "T10",
      "TA",
      "TB",
      "TC",
      "TD",
      "W1",
      "W2",
      "W3",
      "W4",
      "W5",
      "W6",
      "W7",
      "W8",
      "W9",
      "W10",
      "WA",
      "WB",
      "WC",
      "WD",
      "R1",
      "R2",
      "R3",
      "R4",
      "R5",
      "R6",
      "R7",
      "R8",
      "R9",
      "R10",
      "RA",
      "RB",
      "RC",
      "RD",
      "F1",
      "F2",
      "F3",
      "F4",
      "F5",
      "F6",
      "F7",
      "F8",
      "F9",
      "F10",
      "FA",
      "FB",
      "FC",
      "FD",
      "S1",
      "S2",
      "S3",
      "S4",
      "S5",
      "S6",
      "S7",
      "S8",
      "S9",
      "S10",
      "SA",
      "SB",
      "SC",
      "SD",
      "U1",
      "U2",
      "U3",
      "U4",
      "U5",
      "U6",
      "U7",
      "U8",
      "U9",
      "U10",
      "UA",
      "UB",
      "UC",
      "UD",
    ],
    info: [],
    show_detial: false,
    detial_info: [],
    isLogin: false,
    account: "",
    name: "",
    select_course: [],
    course_classes: "",
    only_node: false,
    languages: [
      {
        icon: "flag-icon-tw",
        text: "中文",
        lang: "zh",
      },
      {
        icon: "flag-icon-us",
        text: "English",
        lang: "en",
      },
    ],
    select_language: {
      icon: "flag-icon-tw",
      text: "中文",
      lang: "zh",
    },
    showLogin: false,
    showStatic: false,
    showRemind: false,
    LimitOnTheNumber: {},
    MergeCourse: {},
  },
  mutations: {
    setAlertState(state, alert_state) {
      state.alert_state = alert_state;
    },
    setAlertMessage(state, alert_message) {
      state.alert_message = alert_message;
    },
    setLoadingState(state, loading_state) {
      state.loading_state = loading_state;
    },
    setBtnState(state, btn_state) {
      state.btn_state = btn_state;
    },
    setSemesters(state, semesters) {
      state.semesters = semesters;
    },
    clearInfo(state) {
      state.info = [];
    },
    setSelectSemester(state, semester) {
      state.info = []; // clear table;
      state.select_semester = semester;
    },
    setSelectDepartment(state, selectDepartment) {
      state.selectDepartment = selectDepartment;
    },
    setDimensions(state, dimensions) {
      state.dimensions = dimensions;
    },
    setSelectDimension(state, select_dimension) {
      state.select_dimension = select_dimension;
    },
    setShowTimeTable(state, show_time_table) {
      state.show_time_table = show_time_table;
    },
    setOnlyNode(state, only_node) {
      state.only_node = only_node;
    },
    setNodes(state, nodes) {
      state.nodes = nodes;
    },
    setInfo(state, info) {
      // 自訂subSet 及 intersection 方法
      Set.prototype.subSet = function(otherSet) {
        if (this.size > otherSet.size) return false;
        else {
          for (var elem of this) {
            if (!otherSet.has(elem)) return false;
          }
          return true;
        }
      };
      Set.prototype.intersection = function(otherSet) {
        var intersectionSet = new Set();
        for (var elem of otherSet) {
          if (this.has(elem)) intersectionSet.add(elem);
        }
        return intersectionSet;
      };

      var select_node = new Set(state.nodes);
      if (select_node.size < 98) {
        var data_not_show = [];
        // 過濾節次
        info.forEach((x) => {
          try {
            var node_temp = new Set(x.Node.split(","));
          } catch {
            node_temp = new Set(x.Node);
          }
          if (
            state.only_node &&
            (!node_temp.subSet(select_node) || node_temp.size == 0)
          ) {
            data_not_show.push(x.CourseNo);
          } else if (
            !state.only_node &&
            node_temp.intersection(select_node).size == 0 &&
            node_temp.size != 0
          ) {
            data_not_show.push(x.CourseNo);
          }
        });

        // 刪除不要的節次
        for (var i = 0; i < Object.keys(info).length; i++) {
          if (data_not_show.includes(info[i].CourseNo)) {
            info.splice(i, 1);
            i--;
          }
        }
      }

      // 加工
      var lastCourseNo;
      var lastSemester;
      var saveInfo = info;
      //過濾掉沒有上課節次的課程
      if (select_node.size === 0 || select_node.size >= 98) {
        info = saveInfo;
      } else {
        info = info.filter((x) => x.Node !== null);
      }
      info.forEach((x) => {
        if (
          x.Semester == lastSemester &&
          x.CourseNo == lastCourseNo &&
          x.CourseName != "體育必修課程" &&
          x.CourseName != "通識必修（一）" &&
          x.CourseName != "通識必修（二）"
        ) {
          x.CourseNo = "";
          x.Dimension = "";
          x.CourseName = "";
          x.CreditPoint = "";
          x.RequireOption = "";
          x.AllYear = "";
          x.CourseTeacher = "";
        }
        lastSemester = x.Semester;
        lastCourseNo = x.CourseNo;

        if (x.Node != null) {
          // sorting node
          var node_temp = x.Node.split(",");
          node_temp.sort(
            (a, b) =>
              state.times.indexOf(a.substring(1, 3)) -
              state.times.indexOf(b.substring(1, 3))
          );
          node_temp.sort(
            (a, b) =>
              state.days.indexOf(a.substring(0, 1)) -
              state.days.indexOf(b.substring(0, 1))
          );
          x.Node = node_temp.join();
        }

        // add total students
        x.total_students = parseInt(x.ChooseStudent) + parseInt(x.ThreeStudent);

        // replace ThreeCourse Node
        if (x.CourseNo.substring(0, 1) == "3") {
          x.Node = x.ThreeNode;
        }

        // replace RequireOption
        if (x.RequireOption == "R" && this.state.select_language.lang == "zh") {
          x.RequireOption = "必";
        } else if (
          x.RequireOption == "E" &&
          this.state.select_language.lang == "zh"
        ) {
          x.RequireOption = "選";
        }

        // replace AllYear
        if (x.AllYear == "F" && this.state.select_language.lang == "zh") {
          x.AllYear = "全";
        } else if (
          x.AllYear == "H" &&
          this.state.select_language.lang == "zh"
        ) {
          x.AllYear = "半";
        }
      });
      state.info = info;
      this.commit("checkState");
    },
    setInfoStatic(state, info) {
      var last;
      info.forEach((x) => {
        if (x.CourseNo == last) {
          x.CourseNo = "";
          x.Dimension = "";
          x.CourseName = "";
          x.CreditPoint = "";
          x.RequireOption = "";
          x.AllYear = "";
          x.CourseTeacher = "";
        }
        last = x.CourseNo;

        // sorting node
        if (x.Node != null) {
          var node_temp = x.Node.split(",");
          node_temp.sort(
            (a, b) =>
              state.times.indexOf(a.substring(1, 3)) -
              state.times.indexOf(b.substring(1, 3))
          );
          node_temp.sort(
            (a, b) =>
              state.days.indexOf(a.substring(0, 1)) -
              state.days.indexOf(b.substring(0, 1))
          );
          x.Node = node_temp.join();
        }

        // add total students
        x.total_students = parseInt(x.ChooseStudent) + parseInt(x.ThreeStudent);

        // replace ThreeCourse Node
        if (x.CourseNo.substring(0, 1) == "3") {
          x.Node = x.ThreeNode;
        }

        // replace RequireOption
        if (x.RequireOption == "R" && this.state.select_language.lang == "zh") {
          x.RequireOption = "必";
        } else if (
          x.RequireOption == "E" &&
          this.state.select_language.lang == "zh"
        ) {
          x.RequireOption = "選";
        }

        // replace AllYear
        if (x.AllYear == "F" && this.state.select_language.lang == "zh") {
          x.AllYear = "全";
        } else if (
          x.AllYear == "H" &&
          this.state.select_language.lang == "zh"
        ) {
          x.AllYear = "半";
        }
      });
      state.info = info;
    },
    checkState(state) {
      state.info.forEach((info, index) => {
        state.info[index]["disable"] = false;
        Vue.set(state.info, index, state.info[index]);
      });
      state.info.forEach((info, index) => {
        state.select_course.forEach((course) => {
          if (info["CourseNo"] == course["CourseNo"]) {
            state.info[index]["disable"] = true;
            Vue.set(state.info, index, state.info[index]);
          }
        });
      });
    },
    setShowDetial(state, show_detial) {
      state.show_detial = show_detial;
    },
    setDetialInfo(state, detial_info) {
      detial_info.Restrict3 =
        Number(detial_info.NTURestrict) + Number(detial_info.NTNURestrict);
      state.detial_info = detial_info;
    },
    setIsLogin(state, isLogin) {
      state.isLogin = isLogin;
    },
    setAccount(state, account) {
      state.account = account;
    },
    setName(state, name) {
      state.name = name;
    },
    setSelectCourse(state, select_course) {
      state.select_course = select_course;
      this.commit("checkState");
    },
    getSelectCourse() {
      this.dispatch("getSelectCourse");
    },
    setCourseClasses(state, course_classes) {
      state.course_classes = course_classes;
    },
    setonly_node(state, only_node) {
      state.only_node = only_node;
    },
    setSelectLanguage(state, language) {
      state.select_language = language;
    },
    setShowLogin(state, login) {
      state.showLogin = login;
    },
    setShowStatic(state, showStatic) {
      state.showStatic = showStatic;
    },
    setShowRemind(state, showRemind) {
      state.showRemind = showRemind;
    },
    setLimitOnTheNumber(state, data) {
      Vue.set(state, "LimitOnTheNumber", data);
      // state.LimitOnTheNumber = data;
    },
    setMergeCourse(state, data) {
      let total = 0;
      data.forEach((x) => (total = parseInt(x.AllStudent) + total));
      Vue.set(state.MergeCourse, "total", total);
      Vue.set(state.MergeCourse, "course", data);
      /*
      state.MergeCourse.total = total;
      state.MergeCourse.course = data;
      */
    },
    showAlert(state, alert_message) {
      state.alert_state = true;
      state.alert_message = alert_message;
    },
  },
  actions: {
    getAllSemesters({ commit }) {
      fetchWithAuth("api/semestersinfo", {
        method: "GET",
      })
        .then((response) => response.json())
        .then(function(data) {
          let semesters = data;
          let loginEnable = false;
          semesters.forEach((x) => (loginEnable |= x.LoginEnable));
          commit("setSemesters", semesters);
          commit("setShowLogin", loginEnable);
          commit("setShowStatic", semesters[0].Static);
          commit("setShowRemind", semesters[0].ShowRemind);
          ///判斷是URL是否帶有GET Semester參數，有的條件例外處理
          var getUrlString = location.href;
          var url = new URL(getUrlString);

          if (url.searchParams.has("Semester") == false) {
            commit("setSelectSemester", semesters[0].Semester);
          } else {
            var Semester = url.searchParams.get("Semester");
            commit("setSelectSemester", Semester);
          }
        })
        .catch(function(error) {
          commit("setAlertState", true);
          commit("setAlertMessage", error);
        });
    },
    getAllDimensions({ commit }) {
      fetchWithAuth("api/dimensions", {
        method: "GET",
      })
        .then((response) => response.json())
        .then(function(data) {
          var dimensions = data;
          dimensions[0] = { DimContent: "全部", EngContent: "All", DimNo: "" };
          commit("setDimensions", dimensions);
          commit("setSelectDimension", dimensions[0].DimNo);
        })
        .catch(function(error) {
          commit("setAlertState", true);
          commit("setAlertMessage", error);
        });
    },
    queryCourseInfo({ commit }, query_params) {
      commit("setBtnState", true);
      commit("setAlertState", false);
      commit("setLoadingState", true);

      query_params["CourseNotes"] = String(query_params["CourseNotes"]);
      query_params["CampusNotes"] = String(query_params["CampusNotes"]);

      fetchWithAuth("api/courses", {
        method: "POST",
        body: JSON.stringify(query_params),
        headers: {
          "Content-Type": "application/json; charset=utf-8",
        },
      })
        .then((respone) => respone.json())
        .then(function(data) {
          for (let i = 0; i < data.length; i++) {
            var temp = "";
            const myArray = data[i].Contents.split("／");
            for (let j = 0; j < myArray.length; j++) {
              if (myArray[j].includes("PBL")) {
                temp += "<B style='color:red'>" + myArray[j] + "</B> ";
              } else if (
                myArray[j].includes("遠距") ||
                myArray[j].includes("創新")
              ) {
                temp += "<B style='color:#0000CD'>" + myArray[j] + "</B> ";
              } else {
                temp += myArray[j];
              }
              if (myArray.length - 1 != j) {
                temp += "／";
              }
            }
            data[i].Contents = temp;
          }
          commit("setInfo", data);
          commit("setBtnState", false);
          commit("setLoadingState", false);
        })
        .catch(function(error) {
          commit("setAlertState", true);
          commit("setAlertMessage", error);
          commit("setBtnState", false);
          commit("setLoadingState", false);
        });
    },
    getCourseSchedule({ commit }, param) {
      commit("setBtnState", true);
      commit("setAlertState", false);
      commit("setLoadingState", true);
      fetchWithAuth("api/CourseSchedule", {
        method: "POST",
        body: JSON.stringify(param),
        headers: {
          "Content-Type": "application/json; charset=utf-8",
        },
      })
        .then((respone) => respone.json())
        .then(function(data) {
          commit("setInfo", data);
          commit("setBtnState", false);
          commit("setLoadingState", false);
        })
        .catch(function(error) {
          commit("setAlertState", true);
          commit("setAlertMessage", error);
          commit("setBtnState", false);
          commit("setLoadingState", false);
        });
    },
    getCancleCourse({ commit }) {
      commit("setBtnState", true);
      commit("setAlertState", false);
      commit("setLoadingState", true);
      fetchWithAuth("api/CancleCourse")
        .then((respone) => respone.json())
        .then(function(data) {
          commit("setInfo", data);
          commit("setBtnState", false);
          commit("setLoadingState", false);
        })
        .catch(function(error) {
          commit("setAlertState", true);
          commit("setAlertMessage", error);
          commit("setBtnState", false);
          commit("setLoadingState", false);
        });
    },
    queryDetial({ commit }, payload) {
      var course_no=payload.courseNo;
      var semester=payload.Semester;
      if(semester=="")
      {
        semester=this.state.select_semester;
      }
      var url =
        "api/coursedetials" +
        "?semester=" +
        String(semester) +
        "&course_no=" +
        String(course_no) +
        "&language=" +
        String(this.state.select_language.lang);

      fetchWithAuth(
        "api/LimitOnTheNumber?" +
          "semester=" +
          String(semester) +
          "&courseNo=" +
          String(course_no) +
          "&mylanguage=" +
          String(this.state.select_language.lang),
        {
          method: "GET",
        }
      )
        .then((respone) => respone.json())
        .then((data) => {
          data.Display = data.Display == "true";
          commit("setLimitOnTheNumber", data);
        });

      fetchWithAuth(url, {
        method: "GET",
      })
        .then((response) => response.json())
        .then(function(data) {
          if (course_no.substring(0, 1) != "3" && data[0]["coursehttp"] != "") {
            data[0]["coursehttp"] = "http://" + data[0]["coursehttp"];
          }
          commit("setDetialInfo", data[0]);
          commit("setShowDetial", true);
        })
        .catch(function(error) {
          commit("setAlertState", true);
          commit("setAlertMessage", error);
        });

      fetchWithAuth(
        "api/MergeCourse?" +
          "semester=" +
          String(semester) +
          "&courseNo=" +
          String(course_no) +
          "&mylanguage=" +
          String(this.state.select_language.lang),
        {
          method: "GET",
        }
      )
        .then((respone) => respone.json())
        .then((data) => {
          commit("setMergeCourse", data);
        });
    },
    exportCourseDetialPDF({ commit }, payload) {
      var course_no=payload.courseNo;
      var semester=payload.Semester;
      if(semester=="" || semester==undefined)
      {
        semester=this.state.select_semester;
      }
      var url =
        "api/coursepdf" +
        "?semester=" +
        String(semester) +
        "&courseno=" +
        String(course_no) +
        "&language=" +
        String(this.state.select_language.lang);
      fetchWithAuth(url, {
        method: "GET",
      })
        .then((respone) => respone.json())
        .then(function(data) {
          if (data["Success"]) {
            window.location.href = process.env.VUE_APP_BASE_URL+"Report.aspx?semester=" +String(semester) +"&courseno=" +String(course_no);
          }
        })
        .catch(function(error) {
          commit("setAlertState", true);
          commit("setAlertMessage", error);
        });
    },
    postLogin({ commit }, data) {
      fetchWithAuth("api/Login", {
        method: "POST",
        body: JSON.stringify(data),
        headers: {
          "Content-Type": "application/json; charset=utf-8",
        },
      })
        .then((response) => response.json())
        .then(function(data) {
          if (data["Success"]) {
            VueCookie.set("SessionId", data["SessionID"]);
            window.location = process.env.BASE_URL;
          } else {
            commit("setAlertState", true);
            commit("setAlertMessage", data["Message"]);
          }
        })
        .catch(function(error) {
          commit("setAlertState", true);
          commit("setAlertMessage", error);
        });
    },
    async isLogin({ commit }) {
      fetch("api/Course", {
        method: "GET",
        mode: "cors",
        credentials: "include",
      })
        .then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response.json();
          }
        })
        .then((data) => {
          if (data != null) {
            commit("setSelectCourse", data);
          }
        })
        .catch(function (error) {
          commit("setAlertState", true);
          commit("setAlertMessage", error);
        });

      try {
        const response = await fetchWithAuth("api/OAuth2/CheckLogin", {
          method: "GET",
        });
        const data = await response.json();
        if (data.Success ) {
          if(!data.isEmployee)
            {
              commit("setIsLogin", true);
              commit("setAccount", data.Account);
              commit("setName", data.Name);
            } else {
              // 職員 → 不允許登入（職員不需進來這套系統）
              commit("setIsLogin", false);
              // 只是不要導向 SSO
        
              const apiUrl = process.env.VUE_APP_API_BASE_URL+"/";
              const controller = "OAuth2";
              var cleanUrl="";
              if (!window.location.href)
                  cleanUrl= "/";
              else{
                const decoded = decodeURIComponent(window.location.href);
                cleanUrl=decoded.split("#")[0]; // 移除 fragment (#)
              }
              const encodedReturn = encodeURIComponent(cleanUrl);
              window.location.href = `${apiUrl}${controller}/Logout?returnUrl=${encodedReturn}`;
              commit("showAlert", "非學生帳號不能登入課程查詢系統!");
            }
        } else {
          // ❗ 未登入 → 允許匿名訪客查詢，不要 redirect
          commit("setIsLogin", false);
          // 🧠 保護：避免重導循環
          const currentUrl = window.location.href;
          if (
            currentUrl.includes("/OAuth2/Login") ||
            currentUrl.includes("signin-oidc")
          ) {
            console.warn("目前已在登入流程中，停止重導");
            return;
          }

          // 🧩 設定 localStorage 標記，避免多次 redirect
          // if (!localStorage.getItem("redirecting")) {
          //   localStorage.setItem("redirecting", "true");
          //   console.warn("未登入 → 導向 SSO Login...");
          //   window.location.href = process.env.VUE_APP_BASE_URL+`api/OAuth2/Login?returnUrl=${encodeURIComponent(
          //     currentUrl
          //   )}`;
          // }
        }
      } catch (err) {
        console.error("❌ isLogin 檢查錯誤:", err);
        commit("setIsLogin", false);
      }
    },
    getSelectCourse({ commit }) {
      fetchWithAuth("api/course", {
        method: "GET",
      })
        .then((response) => response.json())
        .then(function(data) {
          commit("setSelectCourse", data);
        })
        .catch(function(error) {
          commit("setAlertState", true);
          commit("setAlertMessage", error);
        });
    },
    pushSelectCourse({ commit }, select_course) {
      var data = {
        Semester: select_course.Semester,
        CourseNo: select_course.CourseNo,
        CourseName: select_course.CourseName,
        Language: this.state.select_language.lang,
      };
      fetchWithAuth("api/course", {
        method: "POST",
        body: JSON.stringify(data),
        headers: {
          "Content-Type": "application/json; charset=utf-8",
        },
      })
        .then((response) => response.json())
        .then(function(data) {
          commit("setAlertState", true);
          commit("setAlertMessage", data["Message"]);
          if (!data["CheckResult"]) {
            commit("getSelectCourse");
          }
        })
        .catch(function(error) {
          commit("setAlertState", true);
          commit("setAlertMessage", error);
        });
    },
    deleteSelectCourse({ commit }, select_course) {
      var data = {
        Semester: select_course.Semester,
        CourseNo: select_course.CourseNo,
        CourseName: select_course.CourseName,
        Language: this.state.select_language.lang,
      };
      fetchWithAuth("api/course", {
        method: "DELETE",
        body: JSON.stringify(data),
        headers: {
          "Content-Type": "application/json; charset=utf-8",
        },
      })
        .then((response) => response.json())
        .then(function(data) {
          commit("setAlertState", true);
          commit("setAlertMessage", data["Message"]);
          commit("getSelectCourse");
        })
        .catch(function(error) {
          commit("setAlertState", true);
          commit("setAlertMessage", error);
        });
    },
    getCourseClasses({ commit }, select_course) {
      var url =
        "api/courseclasses" +
        "?semester=" +
        String(select_course.Semester) +
        "&course_no=" +
        String(select_course.CourseNo);

      fetchWithAuth(url, {
        method: "GET",
      })
        .then((respone) => respone.json())
        .then(function(data) {
          commit("setCourseClasses", data);
        })
        .catch(function(error) {
          commit("setAlertState", true);
          commit("setAlertMessage", error);
        });
    },
    getStaticData({ commit }, file_name) {
      var url = process.env.BASE_URL + "static_data/" + String(file_name);
      fetchWithAuth(url, {
        method: "GET",
      })
        .then((respone) => respone.json())
        .then(function(data) {
          commit("setInfoStatic", data);
          commit("setBtnState", false);
        })
        .catch(function(error) {
          commit("setAlertState", true);
          commit("setAlertMessage", error);
        });
    },
  },
});
